import { PagePending } from "@/components/ui/PagePending";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/supporters")({
  pendingComponent: PagePending,
  beforeLoad: () => ({
    breadcrumb: "Supporters",
  }),
});
